import React, { useContext } from "react";
import { Redirect, Route } from "react-router-dom";
import { Context } from "@/contexts/AuthContext";

const PrivateRoute = ({ component: Component, ...props }) => {
	const { authenticated } = useContext(Context);

	return (
		<Route
			{...props}
			render={() =>
				authenticated ? <Component {...props} /> : <Redirect to={`${process.env.PUBLIC_URL}/`} />
			}
		/>
	);
};

export default PrivateRoute;
